import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { Label as LabelIcon } from '@mui/icons-material';

const TagChip = ({ tag, size = "small", onDelete, clickable = false, onClick }) => {
  const handleClick = (e) => {
    if (clickable && onClick) {
      e.stopPropagation();
      onClick(tag);
    }
  };

  const handleDelete = (e) => {
    if (onDelete) {
      e.stopPropagation();
      onDelete(tag);
    }
  };

  return (
    <Tooltip title={tag.description || tag.name} arrow>
      <Chip
        icon={<LabelIcon style={{ fontSize: size === "small" ? 14 : 16 }} />}
        label={tag.name}
        size={size}
        clickable={clickable}
        onClick={handleClick}
        onDelete={onDelete ? handleDelete : undefined}
        sx={{
          backgroundColor: tag.color,
          color: '#ffffff',
          fontWeight: 500,
          '&:hover': {
            backgroundColor: tag.color,
            filter: 'brightness(0.9)',
          },
          '& .MuiChip-icon': {
            color: '#ffffff',
          },
          '& .MuiChip-deleteIcon': {
            color: '#ffffff',
            '&:hover': {
              color: '#ffffff',
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
            },
          },
        }}
      />
    </Tooltip>
  );
};

export default TagChip;